<template>
  <div class="mb-6 flex flex-col 2xl:flex-row justify-between items-start 2xl:items-center gap-4">
    <!-- Filters Container -->
    <div class="flex flex-col 2xl:flex-row items-start 2xl:items-center gap-3 w-full 2xl:w-auto">
      <!-- Search Input -->
      <input
        :value="search"
        @input="handleSearchInput"
        type="search"
        placeholder="Search claims..."
        class="px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-black text-gray-900 dark:text-white placeholder-gray-500 focus:ring-2 focus:outline-none shadow-sm w-full 2xl:min-w-[300px] transition-colors duration-200 brand-focus-ring"
      >

      <!-- Status Filter -->
      <select
        :value="status"
        @change="handleStatusChange"
        class="px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-black text-gray-900 dark:text-white focus:ring-2 focus:outline-none shadow-sm transition-colors duration-200 brand-focus-ring w-full 2xl:w-auto"
      >
        <option value="">All Status</option>
        <option value="under review">Under Review</option>
        <option value="approved">Approved</option>
        <option value="rejected">Rejected</option>
      </select>

      <!-- Brand Filter -->
      <select
        :value="brand"
        @change="handleBrandChange"
        class="px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-black text-gray-900 dark:text-white focus:ring-2 focus:outline-none shadow-sm transition-colors duration-200 brand-focus-ring w-full 2xl:w-auto"
      >
        <option value="">All Brands</option>
        <option value="1">Continental</option>
        <option value="2">Falken</option>
      </select>

      <!-- Date Range Filter -->
      <div class="flex flex-col sm:flex-row items-stretch sm:items-center gap-2 w-full 2xl:w-auto">
        <input
          :value="dateFrom"
          @change="handleDateFromChange"
          type="date"
          placeholder="Date From"
          class="px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-black text-gray-900 dark:text-white focus:ring-2 focus:outline-none shadow-sm transition-colors duration-200 brand-focus-ring text-sm w-full"
        >
        <span class="text-gray-500 dark:text-gray-400 text-center sm:text-left hidden sm:inline">to</span>
        <span class="text-gray-500 dark:text-gray-400 text-center sm:hidden">to</span>
        <input
          :value="dateTo"
          @change="handleDateToChange"
          type="date"
          placeholder="Date To"
          class="px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-black text-gray-900 dark:text-white focus:ring-2 focus:outline-none shadow-sm transition-colors duration-200 brand-focus-ring text-sm w-full"
        >
      </div>

      <!-- Clear Filters Button -->
      <button
        type="button"
        class="text-white px-4 py-2 rounded-lg transition-colors duration-200 flex items-center justify-center 2xl:justify-start gap-2 shadow-sm w-full 2xl:w-auto whitespace-nowrap hover:opacity-90"
        style="background-color: var(--brand-primary);"
        @mouseover="(e) => (e.currentTarget as HTMLElement).style.backgroundColor = 'var(--brand-hover)'"
        @mouseout="(e) => (e.currentTarget as HTMLElement).style.backgroundColor = 'var(--brand-primary)'"
        @click="$emit('reset')"
      >
        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.207A1 1 0 013 6.5V4z" />
        </svg>
        <span>Clear Filters</span>
      </button>
    </div>

  </div>
</template>

<script setup lang="ts">
defineProps<{
  search: string;
  status: string;
  brand: string;
  dateFrom: string;
  dateTo: string;
}>();

const emit = defineEmits<{
  'update:search': [value: string];
  'update:status': [value: string];
  'update:brand': [value: string];
  'update:dateFrom': [value: string];
  'update:dateTo': [value: string];
  apply: [];
  reset: [];
}>();

// Auto-filter when search input changes
function handleSearchInput(event: Event) {
  const value = (event.target as HTMLInputElement).value;
  emit('update:search', value);
  emit('apply');
}

// Auto-filter when status changes
function handleStatusChange(event: Event) {
  const value = (event.target as HTMLSelectElement).value;
  emit('update:status', value);
  emit('apply');
}

// Auto-filter when brand changes
function handleBrandChange(event: Event) {
  const value = (event.target as HTMLSelectElement).value;
  emit('update:brand', value);
  emit('apply');
}

// Auto-filter when date from changes
function handleDateFromChange(event: Event) {
  const value = (event.target as HTMLInputElement).value;
  emit('update:dateFrom', value);
  emit('apply');
}

// Auto-filter when date to changes
function handleDateToChange(event: Event) {
  const value = (event.target as HTMLInputElement).value;
  emit('update:dateTo', value);
  emit('apply');
}
</script>

<style scoped>
.brand-focus-ring:focus {
  --tw-ring-color: var(--brand-primary);
  border-color: var(--brand-primary);
}
</style>

